import React, {Component} from 'react'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import './proposal.scss'
import EventBus from '../common/EventBus.js'
import $ from "jquery"
import ProposalContent from "./content.component.jsx"
import {Base64} from "js-base64"
import PromoModal from "./sample/promomodal.component.jsx";
import {FormattedMessage} from "react-intl";
const queryString = require('query-string')

class ProposalSample extends Component {

    constructor(props, context) {
        super(props, context)
        const hash = this.props.match.params.hash

        const uri = queryString.parse(this.props.location.search)
        this.state = {
            hash: hash,
            documentId: uri.documentId,
            proposal: null,
            options: [],
            showApprovedMessage: false,
            uri: uri,
            modal: '',
            hasBeenOpened: false,
        }
        this.handleScroll = this.handleScroll.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll)
        $('#mainContent').click()
        AppContext.getApiClient().get('/proposals/' + this.props.match.params.hash).then(res => {
            let variables = res.attributes.variables
            if (this.state.uri.v) {
                const override  = JSON.parse(Base64.decode(this.state.uri.v))
                for (let attr in override) {
                    if (attr === "sections") {
                        for (let internalName in override[attr]) {
                            variables.sections = variables.sections.map(s => {
                                if (s.attributes.internalName === internalName) {
                                    Object.assign(s.attributes.content, override[attr][internalName])
                                }
                                return s
                            })
                        }
                    } else {
                        Object.assign(variables[attr], override[attr])
                    }

                }

            }
            EventBus.dispatch(EventBus.TopicLocaleChange, {
                locale: variables.global.language,
            })
            this.setState({
                proposal: variables
            })

        })

    }

    handleCloseModal() {
        this.setState({
            modal: '',
            hasBeenOpened: true
        })
    }

    handleScroll(event) {
        const scrollPercent = 100 * $(window).scrollTop() / ($(document).height() - $(window).height());
        if (scrollPercent > 95 && this.state.modal === '' && !this.state.hasBeenOpened) {
            this.openModal()
        }
    }

    openModal() {
        this.setState({
            modal: <PromoModal
                onClose={this.handleCloseModal}
            />
        })
    }

    render() {
        if (!this.state.proposal) {
            return <LoadingSpinner marginTop="20px" />
        }
        var showBranding=this.state.proposal.global.hasBranding
        let sticky = ''
        if (this.state.hasBeenOpened) {
            sticky = <div className={"fixed-bottom bg-light shadow-top"}>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-12 text-center py-3"}>
                            <a href={'#'} className={'btn custom-btn-primary'} onClick={e => {
                                e.preventDefault()
                                this.openModal()
                            }}>
                                <div className={'d-flex align-items-center'}>
                                    <img src="/images/QuoteM_icon_white.png" height="25px" />
                                    <span className={'ml-1'}>
                                        <FormattedMessage
                                            id="proposal.sample.preview.lear_more_btn"
                                            defaultMessage="Learn more about QuoteMachine"
                                        />
                                    </span>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        }

        let bannerStyle = null
        $('body').css('background-color', this.state.proposal.global.backgroundColor)
        if (this.state.proposal.global.backgroundImageUrl) {
            $('body').css({
                backgroundImage: `url(${this.state.proposal.global.backgroundImageUrl})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition:  'center',
                backgroundAttachment: 'fixed',
            })
        } else if (this.state.proposal.global.bannerColor) {
            bannerStyle = {
                backgroundColor: this.state.proposal.global.bannerColor,
                width: '100%',
                height: '40%',
                position: 'absolute',
                zIndex: -1000,
                top: 0,
                left: 0,
            }
        }

        return <div>
            {bannerStyle ? <div style={bannerStyle}>
                <br />
            </div> : ''}
            {this.state.modal}
            <div id={'mainContent'} className="container mb-5 pb-5">
                <ProposalContent showBranding={showBranding} variables={this.state.proposal} editable={false} isSample={true} />
            </div>
            {sticky}
        </div>
    }

}

export default ProposalSample





// WEBPACK FOOTER //
// ./src/proposal/sample.component.jsx